import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import GuestGuard from 'utils/route-guard/GuestGuard';

// web routing
const LoginPage = Loadable(lazy(() => import('features/mockpassLogin/LoginPage')));
const SpLoginPage = Loadable(lazy(() => import('features/spcpLogin/spLogin')));
const CpLoginPage = Loadable(lazy(() => import('features/spcpLogin/cpLogin')));
const RedirectLogin = Loadable(lazy(() => import('features/spcpLogin/redirect')));
const CpLoginRedirect = Loadable(lazy(() => import('features/spcpLogin/cpLoginRedirect')));
const MockSingpassLoginPage = Loadable(lazy(() => import('features/mockpassLogin/MockSingpassLogin')));
const MockCorppassLoginPage = Loadable(lazy(() => import('features/mockpassLogin/MockCorppassLogin')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <GuestGuard>
            <Outlet />
        </GuestGuard>
    ),
    children: [
        {
            name: 'login',
            path: '/login',
            element: <LoginPage />
        },
        // Commented for perf test
        {
            name: 'singpass login',
            path: '/splogin',
            element: <SpLoginPage />
        },
        {
            name: 'corppass login',
            path: '/cplogin',
            element: <CpLoginPage />
        },
        {
            name: 'redirect login',
            path: '/iris/api/sp/callback',
            element: <RedirectLogin />
        },
        {
            name: 'redirect cplogin',
            path: '/iris/api/cp/callback',
            element: <CpLoginRedirect />
        },
        // {
        //     name: 'mocksplogin',
        //     path: '/mocksplogin',
        //     element: <MockSingpassLoginPage />
        // },
        // {
        //     name: 'mockcplogin',
        //     path: '/mockcplogin',
        //     element: <MockCorppassLoginPage />
        // }
    ]
};

export default LoginRoutes;
